const ArticleModel = [
  {
    id: 1,
    title: "How to implement useEffect",
    url: "",
    body: "Before the advent of hooks in React, there was no way to manage side effects in functional components. It was only possible in class components with the presence of some lifecycle..",
    image: "https://media.istockphoto.com/photos/mockup-blank-screen-laptop-computer-and-supplies-on-wooden-table-in-picture-id1344933381?b=1&k=20&m=1344933381&s=170667a&w=0&h=SP9FnSoHtmE-CiNeVT_edNskKR9Q00pADaqCNLfGrbU=",
  },
  {
    id: 2,
    title: "The benefits of using React hooks",
    url: "",
    body: "In this article, I am going to list out the benefits of using hooks from my own experience. I have some level of confidence that after reading this piece, you would fall in love with hooks (not all...",
    image: "https://media.istockphoto.com/photos/businessman-hand-is-on-the-trackpad-typing-on-a-laptop-keyboard-while-picture-id1348546519?b=1&k=20&m=1348546519&s=170667a&w=0&h=yAPirAz86Sk_OXEizRVGz1CA1xTJNBDRRSsyixCFpNg=",
  },
  {
    id: 3,
    title: "Understanding useReducer",
    url: "",
    body: "Before the advent of hooks in React, there was no way to manage side effects in functional components. It was only possible in class components with the presence of some lifecycle..",
    image: "https://images.unsplash.com/photo-1540103711724-ebf833bde8d1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Zml4fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
];

export default ArticleModel;
